import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_GRAY_90, COLOR_PINK } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 28,
    fontWeight: 700,
    lineHeight: '19px',
    color: COLOR_PINK,
  },
  priceText: {
    color: COLOR_GRAY_90,
    fontSize: 30,
    fontWeight: 700,
    lineHeight: '36px',
    paddingTop: theme.spacing(2),
    paddingRight: theme.spacing(0.4),
  },
  line: {
    backgroundColor: COLOR_PINK,
    height: 1,
    width: 225,
  },
  benefitsList: {
    minWidth: 428,
    lineHeight: '8px',

    '& div': {
      display: 'flex',
      alignItems: 'center',
      maxHeight: 35,
    },

    '& svg': {
      color: COLOR_PINK,
    },

    '& p': {
      color: COLOR_GRAY_70,
      fontSize: 16,
      fontFamily: 'Lato',
      marginLeft: 8,
      lineHeight: 1,
    },
  },
  allFeatures: {
    color: COLOR_PINK,
    textDecoration: 'underline',
    fontSize: 14,

    '&:hover': {
      cursor: 'pointer',
    },
  },
}));
